// extracted by mini-css-extract-plugin
module.exports = {"default":"button-back_default__1HYtO","division":"button-back_division__v_XKP"};